var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManageColumns(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "manage-columns"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 0.5C2.17157 0.5 1.5 1.17157 1.5 2V12C1.5 12.8284 2.17157 13.5 3 13.5H7.62506L7.35402 14.5842C7.1836 15.2659 7.75093 15.9061 8.4482 15.819L9.42884 15.6964C9.6495 15.6688 9.85467 15.5685 10.0119 15.4112L15.293 10.1302C15.6835 9.73965 15.6835 9.10648 15.293 8.71596L14.5 7.923V2C14.5 1.17157 13.8284 0.5 13 0.5H3ZM13.2413 7.5L8.5 7.5V9.5H11C11.0647 9.5 11.1265 9.51227 11.1832 9.53462L12.8705 7.74807C12.9776 7.63462 13.1049 7.55188 13.2413 7.5ZM10.2714 10.5H8.5V12.3756L10.2714 10.5ZM7.5 7.5V9.5L2.5 9.5V7.5L7.5 7.5ZM7.5 10.5L2.5 10.5V12C2.5 12.2761 2.72386 12.5 3 12.5H7.5V10.5ZM13.5 6.5V4.5L8.5 4.5V6.5L13.5 6.5ZM7.5 6.5V4.5L2.5 4.5L2.5 6.5L7.5 6.5ZM13.5 3.5V2C13.5 1.72386 13.2761 1.5 13 1.5H3C2.72386 1.5 2.5 1.72386 2.5 2V3.5L13.5 3.5ZM8.32417 14.8267L8.59905 13.7271L13.5975 8.43469L14.5859 9.42307L9.3048 14.7041L8.32417 14.8267Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageColumns);
export default __webpack_public_path__ + "static/media/manage-columns.66d31becf8456700c91c7fe66a80d28a.svg";
export { ForwardRef as ReactComponent };